import React from 'react';
import { Button } from 'design-system-web';

type UnitActionButtonsProps = {
  isPristine: boolean;
  isUpdatingUnit: boolean;
  handleOnUpdate: () => void;
  handleOnCancel: () => void;
  t: any;
};

export const UnitActionButtons = ({
  isPristine,
  isUpdatingUnit,
  handleOnUpdate,
  handleOnCancel,
  t,
}: UnitActionButtonsProps) => (
  <>
    <Button
      testId="saveUnitButton"
      variant="primary"
      size="medium"
      disabled={isPristine}
      onClick={handleOnUpdate}
      loading={isUpdatingUnit}
    >
      {t('web.pages.portal.admin.units.details.edit.saveButton')}
    </Button>
    <Button
      testId="cancelButton"
      variant="secondary"
      size="medium"
      onClick={handleOnCancel}
    >
      {t('web.pages.portal.admin.units.details.edit.cancelButton')}
    </Button>
  </>
);
